import { useEffect, useState } from "react";

export default function AjuanMobile() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  const fetchData = async () => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/ajuan?page=${page}`);
    const result = await res.json();

    setData((prev) => [...prev, ...result.data]);
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  // infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 200
      ) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="p-3 space-y-3 bg-gray-100 min-h-screen">
      {data.map((item, index) => (
        <div
          key={index}
          className="bg-white p-4 rounded-xl shadow-md"
        >
          {/* HEADER */}
          <div className="flex justify-between gap-1 items-center">
            <h2 className="font-semibold text-sm">
              {item.note}
            </h2>

            <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-600">
              {item.read}
            </span>
          </div>

          {/* BODY */}
          <div className="mt-2 text-sm text-gray-600">
            <p>Rp {item.total}</p>
            <p className="text-xs">{item.tanggal_final}</p>
          </div>

          {/* ACTION */}
          <div className="mt-3 flex justify-end">
            <button className="text-xs bg-black text-white px-3 py-1 rounded-lg">
              Detail
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}